import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

const defaultData: IDataLayer = {
  enh_action: 'promo_click',
  event_name: 'navigation_click',
  event_category: 'global',
  event_action: 'navigation click',
  event_label: [], // '<promo_pos> - <promo_creative> - <navigation name> - <navigation link>'
  promo_pos: ['gnav'],
  promo_creative: ['link'],
  promo_name: [], // '<navigation name> - <navigation link>'
  promo_id: [] // '<promo_pos> - <promo_creative> - <navigation name> - <navigation link>'
};

function trackNavigationClick(_: string, eventData: IDataLayer = {}) {
  eventData.promo_name = [
    eventData.promo_name.indexOf('>') === 0
      ? eventData.promo_name.replace(/[>]+/, '')
      : eventData.promo_name
  ];
  eventData.event_label = ['gnav' + '-' + 'link' + '-' + eventData.promo_name];
  eventData.promo_id = ['gnav' + '-' + 'link' + '-' + eventData.promo_name];
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('navigationClick', trackNavigationClick);
